import { Form } from "@quillforms/renderer-core";
import "@quillforms/renderer-core/build-style/style.css";
import "./App.css";
import { useEffect } from 'react';
import { convertFormat, submitLeads } from './utils'; // Adjust the path as needed
import image from './images/dog_bite.webp';

export const DogBiteForm = () => {
  useEffect(() => {
    document.title = 'Best Dog Bite Plastic Surgeon in Gurgaon!'; // Set the desired title
  }, []); //
  return (
    <div style={{ width: "100%", height: "100vh" }}>
      
      <Form
        formId="1"
        formObj={{
          blocks: [
            {
              name: "welcome-screen",
              id: "jg1401r",
              attributes: {
                buttonText: "Next",
                label: "<b>Expert Plastic Surgeon for Dog Bites!<b><br>🌟🌟🌟🌟🌟",
                customHTML: `<br><b>Dr. Shikha Bansal</b><br>
                MBBS, MS, MCh.<br>
                Plastic & Reconstructive Surgery
                <h2>Heal From Dog Bite Wounds & Scars!</h2>
                Rapid Healing & Recovery&nbsp;&nbsp; ✅<br>
                Scar Minimization & Revision&nbsp;&nbsp;✅<br>
                Minimally Invasive Techniques&nbsp;&nbsp;✅<br>
                Affordable Treatment&nbsp;&nbsp;✅
                `,
                attachment: {
                  type: "image",
                  url: image
                },
                attachmentMaxWidth: "250px"
              }
            },
           {
              "name": "multiple-choice",
              "id": "q_where",
              "attributes": {
                "required": true,
                "label": "Where is the dog bite located on the body?",
                "choices": [
                  {"label": "Hand/Finger", "value": "finger"},
                  {"label": "Arm", "value": "arm"},
                  {"label": "Leg", "value": "leg"},
                  {"label": "Face", "value": "face"},
                  {"label": "Multiple", "value": "multiple"},
                  {"label": "Other", "value": "other"}
                ]
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_when_happen",
              "attributes": {
                "label": "When did the dog bite happen?",
                "choices": [
                  {
                    "label": "Today",
                    "value": "today"
                  },
                  {
                    "label": "Yesterday",
                    "value": "yesterday"
                  },
                  {
                    "label": "2 to 5 days ago",
                    "value": "2_5_days_ago"
                  },
                  {
                    "label": "5 days to 1 month ago",
                    "value": "5_days_to_1_month"
                  },
                  {
                    "label": "Over 1 month",
                    "value": "over_1_month"
                  }
                ]
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_age_group",
              "attributes": {
                "required": true,
                "label": "What's the age group of patient?",
                "description": "This is going to help us make the best recommendations to you",
                "choices": [
                  {
                    "label": "Below 18",
                    "value": "below_18"
                  },
                  {
                    "label": "18-30",
                    "value": "18_to_30"
                  },
                  {
                    "label": "31-50",
                    "value": "31_to_50"
                  },
                  {
                    "label": "51-65",
                    "value": "51_to_65"
                  },
                  {
                    "label": "Above 65",
                    "value": "above_65"
                  }
                ]
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_location",
              "attributes": {
                "label": "Where is the patient located?",
                "description": "This is going to help us make the best recommendations to you",
                "choices": [
                  {
                    "label": "Gurgaon",
                    "value": "gurgaon"
                  },
                  {
                    "label": "Delhi",
                    "value": "delhi"
                  },
                  {
                    "label": "Faridabad",
                    "value": "faridabad"
                  },
                  {
                    "label": "Ghaziabad",
                    "value": "ghaziabad"
                  },
                  {
                    "label": "Other",
                    "value": "other"
                  }
                ]
              },
            },
            {
              "name": "multiple-choice",
              "id": "q_when",
              "attributes": {
                "label": "How soon are you looking for a treatment?",
                "choices": [
                  {
                    "label": "As soon as possible",
                    "value": "asap"
                  },
                  {
                    "label": "Within a week",
                    "value": "within_a_week"
                  },
                  {
                    "label": "Within a month",
                    "value": "within_a_month"
                  },
                  {
                    "label": "> 1 month",
                    "value": "more_than_a_month"
                  },
                  {
                    "label": "Not sure",
                    "value": "not_sure"
                  }
                ]
              }
            },
            {
              name: "short-text",
              id: "name",
              attributes: {
                classnames: "first-block",
                required: true,
                label: "What's your name?"
              }
            },
            {
              name: "number",
              id: "phone",
              attributes: {
                classnames: "first-block",
                required: true,
                label: "What's your phone number?"
              }
            },
            
          ],
          messages: {
            'block.defaultThankYouScreen.label': 'Thanks! We\'ll be in touch soon!'
          },
          settings: {
            animationDirection: "vertical",
            disableWheelSwiping: false,
            disableNavigationArrows: false,
            disableProgressBar: false,
            showQuestionsNumbers: true
          },
          theme: {
            font: "Roboto",
            questionsColor: "#1c3d5a",
            buttonsBgColor: "#1c3d5a",
            logo: {
              src: ""
            },
            answersColor: "#1c3d5a",
            buttonsFontColor: "#fff",
            buttonsBorderRadius: 25,
            errorsFontColor: "#fff",
            errorsBgColor: "#f00",
            progressBarFillColor: "#1c3d5a",
            progressBarBgColor: "#ccc"
          }
        }}
        onSubmit={(data, { completeForm, setIsSubmitting, setSubmissionErr }) => {
          let convertedData = convertFormat(data);
          convertedData['type'] = 'dog_bite'
          console.log(JSON.stringify(convertedData));
          let mode = window.location.hostname === 'localhost' ? 'dev' : 'prod';
          submitLeads(convertedData, { mode, targets: 'both', successPolicy: 'any', mockSuccess: true })
            .then(() => {
              setIsSubmitting(false);
              completeForm();
              setTimeout(() => {
                window.location.href = 'https://drshikhabansal.com';
              }, 3000);
            })
            .catch((error) => {
              setIsSubmitting(false);
              setSubmissionErr(error.message);
              console.error('Lead submission error details:', error.result || error);
            });
        }}
      />
    </div>
  );
};
